import {FeatureFlagsEffects} from '../effects/feature-flags.effects'
import {UiEffects} from '../effects/ui.effects'

export const uiEffects = [
    FeatureFlagsEffects,
    UiEffects
]